module.exports = __webpack_public_path__ + "img/lily.cc3315f2.jpg";